module.exports = {
  title: '返利明细',
  route: {
    path: '/marketing-tools',
    children: {
      path: 'rebate-user-product-details',
    },
  },
};
